export enum GeofenceShapes {
	Circle = "Circle",
	Polygon = "Polygon",
	Rectangle = "Rectangle",
	Polyline = "Polyline",
	None = "None"
}